import baseConfiguratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import { RECEIVE_CONFIGURATION } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { ActionTypes } from './types';
import { getComponent, getOption, getOptionInputValue } from './Selectors';

function updateState(state, action) {
  switch (action.type) {
    case ActionTypes.SET_CUSTOM_DATA: {
      return {
        ...state,
        configuration: {
          ...state.configuration,
          customdata: {
            ...state.configuration.customdata,
            ...action.data,
          },
        },
      };
    }
    case RECEIVE_CONFIGURATION: {
      return {
        ...baseConfiguratorReducer(state, action),
        selectedoptionclassification: {},
      };
    }
    default: {
      return baseConfiguratorReducer(state, action);
    }
  }
}

function removeOutOfRangeObjects(state) {
  const measurementsComponent = getComponent(state.configuration, 'measurements');
  const lengthX = getOptionInputValue(getOption(measurementsComponent, 'wall_length_first')) / 1000;
  const lengthZ = getOptionInputValue(getOption(measurementsComponent, 'wall_length_second')) / 1000;
  const outOfRangeDoors = (state.configuration.customdata?.doors || []).filter(
    (door) =>
      (door.wall === 'wall_1' && door.position + 1 > lengthX) ||
      (door.wall === 'wall_2' && door.position + 1 > lengthZ)
  );
  if (outOfRangeDoors.length) {
    state = updateState(state, {
      type: ActionTypes.SET_CUSTOM_DATA,
      data: {
        doors: state.configuration.customdata.doors.filter((door) => !outOfRangeDoors.includes(door)),
      },
    });
  }
  return state;
}

export default function configuratorReducer(state, action) {
  const nextState = updateState(state, action);
  return removeOutOfRangeObjects(nextState);
}
